import React, { useRef, useState } from "react";
import PageMeta from "../../components/common/PageMeta";
import ComponentCard from "../../components/common/ComponentCard";
import ProductAndSupplier from "../../components/ui/videos/ProductAndSupplier";

function IntroProductAndSuppliers(): JSX.Element {

  return (
    <>
      <PageMeta
        title="User Accounts - Training Videos | Hospitality Genie"
        description="User Accounts - Training Videos"
      />
      <div className="grid grid-cols-1 gap-5 sm:gap-6 xl:grid-cols-1">
        <div className="sspace-y-5 sm:space-y-6">
          <ComponentCard title="Video Ratio 16:9">
            <ProductAndSupplier />
          </ComponentCard>
        </div>
      </div>
      
    </>
  );
}

export default IntroProductAndSuppliers;
